import script from "./NoResultsSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoResultsSearch.vue?vue&type=script&setup=true&lang=ts"

import "./NoResultsSearch.vue?vue&type=style&index=0&id=25940486&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25940486"]])

export default __exports__